module.exports = __webpack_public_path__ + "img/headerBg.29340d9c.png";